import script from "./performanceReport.vue?vue&type=script&setup=true&lang=js"
export * from "./performanceReport.vue?vue&type=script&setup=true&lang=js"

import "./performanceReport.vue?vue&type=style&index=0&id=781a5314&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-781a5314"]])

export default __exports__